function EstimateLeadTimes($eltData = {}){
    if(typeof $eltData.productOptionsSelector === 'undefined' || typeof $eltData.productData === 'undefined' || typeof $eltData.inStockMsg === 'undefined' || typeof $eltData.outOfStockMsg === 'undefined'){
        console.log(`no data in the $eltData variable`);
        return false;
    }

    const $estimateLeadTimesBlock = document.querySelector('.estimate-lead-times-block');
    const $estimateLeadTimesMsg = $estimateLeadTimesBlock.querySelector('.estimate-lead-time-msg');
    const $idSelect = $estimateLeadTimesBlock.closest('form').querySelector('[name="id"]');

    function hasNode($selector){
        return (document.querySelectorAll($selector).length > 0) ? true : false;
    }
    function wait($selector, $resolve, $reject = ()=>{}, $duration = 10, $delay = 2000){
        let $hasElem = false;
        let $interval = setInterval(() => {
            if(hasNode($selector)){
                clearInterval($interval);
                $hasElem = true;
                const $node = document.querySelectorAll($selector);
                $resolve($node);
            }
        },$duration);
        setTimeout(() => {
            if(!$hasElem){
                clearInterval($interval);
                $reject();
            }
        }, $delay);
    }

    function updateMsg($value, $available = ''){
        if($value === 'in-stock'){
            $estimateLeadTimesBlock.dataset.productStatus = 'in-stock';
            if($eltData.inStockMsg !== ''){
                const $a = ($eltData.show_in_stock_qtys && $available !== '') ? `: ${$available} Available` : ``;
                $estimateLeadTimesMsg.innerHTML = $eltData.inStockMsg.trim() + $a;
                $estimateLeadTimesMsg.style.display = 'flex';
            }
            else{
                $estimateLeadTimesMsg.innerHTML = '';
                $estimateLeadTimesMsg.style.display = 'none';
            }
        }
        else{
            $estimateLeadTimesBlock.dataset.productStatus = 'out-of-stock';
            if($eltData.outOfStockMsg !== ''){
                $estimateLeadTimesMsg.innerHTML = $eltData.outOfStockMsg;
                $estimateLeadTimesMsg.style.display = 'flex';
            }
            else{
                $estimateLeadTimesMsg.innerHTML = '';
                $estimateLeadTimesMsg.style.display = 'none';
            }
        }
    }

    if($eltData.productData.length > 0){
        $estimateLeadTimesBlock.style.display = 'flex';
        wait($eltData.productOptionsSelector,($nodes)=>{
            $nodes.forEach(($node)=>{
                $node.addEventListener('change', function(){
                    setTimeout(()=>{
                        if($idSelect.value !== '' && parseInt($idSelect.value) > 0){
                            $eltData.productData.forEach(($data)=>{
                                if(parseInt($idSelect.value) === $data.id){
                                    if($data.inventory > 0){
                                        const $inventory = ($data.inventory > 20) ? `20+` : `${$data.inventory}`;
                                        updateMsg('in-stock', $inventory);
                                    }
                                    else{
                                        updateMsg('out-of-stock');
                                    }
                                }
                            });
                        }
                        else{
                            updateMsg('out-of-stock');
                        }
                    }, 500);
                });
            });
        });
    }
    else{
        $estimateLeadTimesBlock.style.display = 'none';
    }
}
EstimateLeadTimes($eltData);